<template>
    <div>
        <crud-facecade
            ref="anaesthesia-method-list"
            :url="url"
            :columns="columnList"
            :buttons="buttons"
            v-wechat-title="title"
            :tableHeight="tableHeight"
            :addButton="{ enabled: true, permission: 'dic_anesthesia_mode:create' }"
            :deleteButton="{ enabled: false, permission: 'dic_anesthesia_mode_delete' }"
            :updateButton="{ enabled: false, permission: 'dic_anesthesia_mode:update' }"
            @relationAnaesthesiaMethod="relationAnaesthesiaMethod"
        >
        </crud-facecade>
        <relation :title="relation.title" :visible.sync="relation.visible" :item="relation.item" area="AnaesthesiaMethod" @after-relation="reloadListData"></relation>
    </div>
</template>
<script>
import relation from '../Relation'
import { mapGetters } from 'vuex'
export default {
    name: `AnaesthesiaMethod`,
    components: { relation },
    props: {

    },
    data() {
        return {
            title: `基础数据-麻醉方式`,
            url: { baseURL: `/api/AcisSystem/AnaesthesiaMethod` },
            buttons: [],
            ananesthesiaType: [], // 麻醉大类
            relation: {
                title: ``,
                visible: false,
                item: {}
            }
        }
    },
    computed: {
        ...mapGetters([`screenHeight`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        columnList() {
            return [{
                type: `string`,
                prop: `id`,
                label: `编号`,
                // width: "180",
                isListable: false,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                isKey: true,
                default: 0
            },
            {
                type: `number`,
                prop: `display_order`,
                label: `排序`,
                width: `80`,
                isListable: true,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                readonly: false,
                sortable: true,
                isDisplayOrder: true
            },
            {
                type: `string`,
                prop: `code`,
                label: `编码`,
                width: `180`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                // searchable: true,
                readonly: function(that, { row, column, area }) {
                    if (area == `form`) {
                        return row.enum_dic_type === 2
                    } else {
                        return true
                    }
                },
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            },
            {
                type: `string`,
                prop: `abbr`,
                label: `缩写`,
                width: `180`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: false,
                searchable: true,
                sortable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            },
            {
                type: `string`,
                prop: `name`,
                label: `名称`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                // sortable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `select`,
                prop: `enum_dic_type`,
                label: `属性`,
                width: `120`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                sortable: false,
                searchable: true,
                options: function(that, { area }) {
                    if (area == `list` || area == `query`) {
                        return [{ value: 1, label: `院内版` }, { value: 2, label: `非标准` }, { value: 3, label: `互联互通` }, { value: 4, label: `上传` }, { value: 5, label: `国标` }]
                    }
                    return [{ value: 1, label: `院内版` }, { value: 2, label: `非标准` }]
                },
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                change: function(that, { row, column }) {
                    if (row.enum_dic_type === 2) {
                        row.code = `  `
                        row._code_disabled = true
                    }
                }
            }, {
                type: `string`,
                prop: `relation_text`,
                label: `关联麻醉方式`,
                width: `240`,
                isListable: true,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                searchable: true,
                sortable: false
            }, {
                type: `colorpicker`,
                prop: `color_tip`,
                label: `颜色`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true
            }, {
                type: `rbool`,
                prop: `is_deleted`,
                label: `状态`,
                width: `70`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: false,
                readonly: false,
                options: `is_enabled`,
                default: false
            }, {
                type: `buttongroup`,
                prop: `oper`,
                label: `操作`,
                width: `180`,
                fixed: `right`,
                config: {
                    align: `flex-start`
                },
                isListable: true,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                searchable: false,
                sortable: false,
                readonly: false,
                options: function(that, { row }) {
                    if (row.enum_dic_type >= 3) {
                        return [{
                            class: `is-plain`,
                            label: `关联麻醉方式`,
                            icon: ``,
                            type: `primary`,
                            emit: `relationAnaesthesiaMethod`,
                            permission: `dic_anesthesia_mode:relation`
                        }]
                    } else {
                        return [{
                            class: `is-plain`,
                            label: `关联麻醉方式`,
                            icon: ``,
                            type: `primary`,
                            emit: `relationAnaesthesiaMethod`,
                            permission: `dic_anesthesia_mode:relation`
                        }, {
                            class: `is-plain`,
                            label: `编辑`,
                            icon: ``,
                            type: `primary`,
                            emit: `LoadingUpdateView`,
                            permission: `dic_anesthesia_mode:update`
                        }]
                    }
                }

            }]
        }
    },
    mounted() {
        // this.addGb()
    },
    methods: {
        // addGb(){
        //   let that = this
        //   that.myaxios.get("/api/AcisSystem/AnaesthesiaMethod/SearchGb").then(data=>{
        //     that.ananesthesiaType=data
        //   })
        // }
        relationAnaesthesiaMethod({ index, row }) {
            this.relation.title = `关联麻醉方式`
            // console.log(row)
            this.$set(this.relation, `item`, { ...row })
            this.relation.visible = true
        },
        reloadListData() {
            this.$refs[`anaesthesia-method-list`].ReloadListData()
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dictionary/AnaesthesiaMethod/Index.vue